# Classic Job Posting

This use case provides technical implementation details for our classic Job Posting product.
You can find more information and request an integration on its [product page].

The SEEK API can be used to post job ads on the SEEK job board.
Job ads are explicitly created via GraphQL mutations.

[product page]: https://au.employer.seek.com/partners/connect-with-seek#seek-job-posting
